import cta from '~/components/atoms/a-ctas/a-cta-v2.data'
export default {
  eyebrow: 'Latest',
  heading:
    'Tribal Worldwide<span>.</span><br />Total Experience Agency<span>.</span>',
  copy: 'We build experience ecosystems that build better business.',
  cta: [
    {
      ...cta,
      copy: 'Find out more',
      href: {
        url: '/about-us',
        cached_url: '/about-us',
      },
      type: 'primary',
    },
  ],
}
